import React from "react";
import { Col, Row } from "react-bootstrap";
import { 
  DiJavascript1, DiReact, DiPython, DiGit, DiDjango, DiHtml5, DiCss3,
  DiDocker, DiAws 
} from "react-icons/di";
import { 
  SiRedis, SiPostgresql, SiFlask, SiFastapi, SiBootstrap, 
  SiTailwindcss, SiTensorflow, SiPytorch, SiScikitlearn, SiOpencv, 
  SiOpenai, SiWebrtc, SiSocketdotio, SiCelery, 
  SiMongodb, SiElastic, SiNeo4J,
  SiNumpy, SiPandas, SiKeras, SiGithub, SiGooglecloud,
  SiStreamlit
} from "react-icons/si";

// Simple icon component for missing icons
const LangChainIcon = () => <span style={{fontSize: '2.5rem', fontWeight: 700, color: '#10B981'}}>LC</span>;
const HuggingFaceIcon = () => <span style={{fontSize: '2.5rem', fontWeight: 700, color: '#FFD700'}}>HF</span>;

function Techstack() {
  const iconSize = { fontSize: "3rem" };
  const techNameStyle = {
    fontSize: "0.85rem",
    textAlign: "center",
    marginTop: "8px",
    color: "#EDE9FF"
  };

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "20px" }}>
      {/* === CORE LANGUAGES === */}
      <Col xs={4} md={2} className="tech-icons">
        <DiPython size={iconSize} />
        <div style={techNameStyle}>Python</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 size={iconSize} />
        <div style={techNameStyle}>JavaScript</div>
      </Col>

      {/* === BACKEND FRAMEWORKS === */}
      <Col xs={4} md={2} className="tech-icons">
        <DiDjango size={iconSize} />
        <div style={techNameStyle}>Django</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiFastapi size={iconSize} />
        <div style={techNameStyle}>FastAPI</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiFlask size={iconSize} />
        <div style={techNameStyle}>Flask</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiReact size={iconSize} />
        <div style={techNameStyle}>React</div>
      </Col>

      {/* === AI & LLM === */}
      <Col xs={4} md={2} className="tech-icons">
        <SiOpenai size={iconSize} />
        <div style={techNameStyle}>OpenAI / GPT</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <LangChainIcon />
        <div style={techNameStyle}>LangChain</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <HuggingFaceIcon />
        <div style={techNameStyle}>Hugging Face</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPytorch size={iconSize} />
        <div style={techNameStyle}>PyTorch</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiTensorflow size={iconSize} />
        <div style={techNameStyle}>TensorFlow</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiKeras size={iconSize} />
        <div style={techNameStyle}>Keras</div>
      </Col>

      {/* === ML & NLP === */}
      <Col xs={4} md={2} className="tech-icons">
        <SiScikitlearn size={iconSize} />
        <div style={techNameStyle}>Scikit-learn</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiNumpy size={iconSize} />
        <div style={techNameStyle}>NumPy</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPandas size={iconSize} />
        <div style={techNameStyle}>Pandas</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiOpencv size={iconSize} />
        <div style={techNameStyle}>OpenCV</div>
      </Col>

      {/* === VECTOR DATABASES === */}
      <Col xs={4} md={2} className="tech-icons">
        <SiNeo4J size={iconSize} />
        <div style={techNameStyle}>Graph DB</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiElastic size={iconSize} />
        <div style={techNameStyle}>Elasticsearch</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiNeo4J size={iconSize} />
        <div style={techNameStyle}>Neo4j</div>
      </Col>

      {/* === DATABASES === */}
      <Col xs={4} md={2} className="tech-icons">
        <SiPostgresql size={iconSize} />
        <div style={techNameStyle}>PostgreSQL</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiRedis size={iconSize} />
        <div style={techNameStyle}>Redis</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMongodb size={iconSize} />
        <div style={techNameStyle}>MongoDB</div>
      </Col>
<Col xs={4} md={2} className="tech-icons">
        <SiStreamlit size={iconSize} />
        <div style={techNameStyle}>Streamlit</div>
      </Col>

      {/* === CLOUD & DEVOPS === */}
      <Col xs={4} md={2} className="tech-icons">
        <DiAws size={iconSize} />
        <div style={techNameStyle}>AWS</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiGooglecloud size={iconSize} />
        <div style={techNameStyle}>GCP</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiDocker size={iconSize} />
        <div style={techNameStyle}>Docker</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiGithub size={iconSize} />
        <div style={techNameStyle}>GitHub</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiGit size={iconSize} />
        <div style={techNameStyle}>Git</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiCelery size={iconSize} />
        <div style={techNameStyle}>Celery</div>
      </Col>

      {/* === REAL-TIME === */}
      <Col xs={4} md={2} className="tech-icons">
        <SiWebrtc size={iconSize} />
        <div style={techNameStyle}>WebRTC</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiSocketdotio size={iconSize} />
        <div style={techNameStyle}>WebSocket</div>
      </Col>

      {/* === FRONTEND === */}
      <Col xs={4} md={2} className="tech-icons">
        <DiHtml5 size={iconSize} />
        <div style={techNameStyle}>HTML5</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiCss3 size={iconSize} />
        <div style={techNameStyle}>CSS3</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiTailwindcss size={iconSize} />
        <div style={techNameStyle}>Tailwind</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiBootstrap size={iconSize} />
        <div style={techNameStyle}>Bootstrap</div>
      </Col>

    </Row>
  );
}

export default Techstack;
